import { MultiPolicySelector } from "components/page-header/desktop-header/multi-policy-selector";
import NavMenu from "components/shared/nav-menu";
import { useNavItems } from "hooks/useNavItems";

import styles from "./navigation.module.scss";

export const Navigation = () => {
  const navItems = useNavItems();

  return (
    <div className={styles.navigation} data-testid="secondary-header">
      <div className={styles.policyAddressContainer}>
        <MultiPolicySelector />
      </div>
      <NavMenu navItems={navItems} />
    </div>
  );
};
